import { useQuery } from '@tanstack/react-query';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';
import { AttendanceCheckApi } from 'api/ApiHelper';

export const useGetAttendanceCheckMonthsQuery = () =>
  useQuery({ queryKey: activityPointQueryKey.attendanceCheckMonths, queryFn: () => AttendanceCheckApi.findMonths() });
